import React from 'react';
import { Trash2 } from 'lucide-react';
import { Button } from './ds';

const FONT = "'IBM Plex Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif";

const DeleteAuditModal = ({ target, deleting, onCancel, onConfirm }) => (
  <>
    <div
      onClick={() => !deleting && onCancel()}
      style={{ position: 'fixed', inset: 0, zIndex: 900, background: 'rgba(10,14,23,0.45)', backdropFilter: 'blur(2px)' }}
    />
    <div style={{
      position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%,-50%)',
      zIndex: 910, background: '#fff', borderRadius: 16, padding: '32px 36px',
      border: '1px solid #D7DCE4', boxShadow: '0 12px 28px rgba(16,22,35,0.10), 0 4px 10px rgba(16,22,35,0.05)',
      width: 400, fontFamily: FONT,
    }}>
      <div style={{
        width: 40, height: 40, borderRadius: 10, background: '#FDF1F1', color: '#C22B31',
        display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16,
      }}>
        <Trash2 width={19} height={19} />
      </div>
      <h3 style={{ margin: '0 0 8px', fontSize: 16, fontWeight: 700, color: '#101623' }}>
        Audit löschen?
      </h3>
      <p style={{ margin: '0 0 6px', fontSize: 13, color: '#667085', lineHeight: 1.6 }}>
        <strong style={{ color: '#101623' }}>{target.title || 'Audit'}</strong>
        {' '}vom{' '}
        {new Date(target.completedAt || target.updatedAt || target.createdAt)
          .toLocaleDateString('de-DE', { day: 'numeric', month: 'long', year: 'numeric' })}
      </p>
      <p style={{ margin: '0 0 24px', fontSize: 13, color: '#C22B31' }}>
        Alle Antworten werden unwiderruflich gelöscht.
      </p>
      <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
        <Button variant="secondary" size="md" onClick={onCancel} disabled={deleting}>Abbrechen</Button>
        <Button variant="danger" size="md" onClick={onConfirm} disabled={deleting}>{deleting ? 'Löscht…' : 'Ja, löschen'}</Button>
      </div>
    </div>
  </>
);

export default DeleteAuditModal;
